import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormValueSummaryFieldComponent} from './form-value-summary-field.component';
import {SummaryFieldModule} from '../../../../../../core/component/summary-field/summary-field.module';
import {
    DocumentSummaryModelFieldModule
} from '../../../../../../document/common/api/component/document-summary-field/document-summary-field.module';
import {MatTooltipModule} from "@angular/material/tooltip";
import {
    ImagePreviewDialogComponent
} from "../../../../../../core/component/image-preview-dialog/image-preview-dialog.component";
import {FormFieldModule} from "../../../../../../core/component/form-field/form-field.module";

@NgModule({
    imports: [
        CommonModule,
        SummaryFieldModule,
        DocumentSummaryModelFieldModule,
        MatTooltipModule,
        ImagePreviewDialogComponent,
        FormFieldModule,
    ],
    declarations: [FormValueSummaryFieldComponent],
    exports: [
        FormValueSummaryFieldComponent
    ]
})
export class FormValueSummaryFieldModule {
}
